import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';

import AdminNavigation from './navigation-component';
import AdminDashboardComponent from './component';
import bookingsListComponent from './bookings/bookings-list-component';
import bookingDetailComponent from './bookings/booking-detail-component';
import listingListComponent from './listings/listings-list-component';
import listingRouteComponent from './listings/route-table';
import userListComponent from './users/users-list-component';
import streamlineAccountForm from './streamline-account/streamline-account-form';

const mapStateToProps = state => ({
  global: state.Global,
  user: state.Dashboard.user
});

class RouteTable extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    let { global, user, history } = this.props;
    if ((!global.userId)
      || (user && user.userType !== 'admin')) {
      history.replace('/login');
    }
  }

  componentDidUpdate() {
    let { user, history, global } = this.props;
    if (!global.userId || (user && user.userType !== 'admin')) {
      history.replace('/login');
    }
  }

  render() {
    return (<div>
      <AdminNavigation />
      <Route exact path="/admin" component={AdminDashboardComponent} />
      <Route exact path="/admin/bookings" component={bookingsListComponent} />
      <Route exact path="/admin/bookings/:id" component={bookingDetailComponent} />
      <Route exact path="/admin/manage-listings" component={listingListComponent} />
      <Route exact path="/admin/users" component={userListComponent} />
      <Route exact path="/admin/streamline-account" component={streamlineAccountForm} />
      <Route path="/admin/listing/edit" component={listingRouteComponent} />
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(RouteTable));
